import React from "react";
import { Row, Col, Button, MessageBanner } from "@folio/stripes/components";
import { useFieldArray, useFormContext } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import { firstOnix } from "../../utils/selectMappers";
import { useOnixOptions } from "../../hooks/title/useOnixOptions";
import { pickFirstCzechLanguage } from "../../utils/pickFirstCzechLanguage";
import { useItemEditor } from "../../hooks/title/useItemEditor";
import { useContentRows } from "../../utils/toContentRows";
import { FormSectionModal } from "./FormSectionModal";
import { useFieldArrayErrors } from "../../hooks/useFieldArrayErrors";
import { EntityRowList } from "./EntityRowList";
import css from "./FormModal.module.css";
var TitleTextContentsForm = function () {
    var _a, _b;
    var formatMessage = useIntl().formatMessage;
    var _c = useFormContext(), control = _c.control, getValues = _c.getValues;
    var errorMessages = useFieldArrayErrors("textContents");
    var _d = useFieldArray({ control: control, name: "textContents" }), contentFields = _d.fields, appendContent = _d.append, updateContent = _d.update, removeContent = _d.remove;
    var _e = useOnixOptions(), languageTable = _e.languageTable, languageLoading = _e.languageLoading, languageStatus = _e.languageStatus, textContentTypeTable = _e.textContentTypeTable, textContentTypeLoading = _e.textContentTypeLoading, textContentTypeStatus = _e.textContentTypeStatus;
    var _f = useItemEditor({
        appendItem: appendContent,
        updateItem: updateContent,
        createEmpty: function () { return ({
            type: firstOnix(textContentTypeTable),
            text: "",
            language: pickFirstCzechLanguage(languageTable === null || languageTable === void 0 ? void 0 : languageTable.onixCodetableItems),
        }); },
    }), isOpen = _f.isOpen, isEditing = _f.isEditing, draft = _f.draft, setDraft = _f.setDraft, openEditor = _f.openEditor, closeEditor = _f.closeEditor, saveItem = _f.saveItem;
    var contentData = useContentRows(contentFields);
    var columns = [
        {
            name: formatMessage({ id: "ui-br-agency.title.textContents.type.label" }),
            cellRenderer: function (row) { var _a; return ((_a = row.type) === null || _a === void 0 ? void 0 : _a.description) || "-"; },
        },
        {
            name: formatMessage({ id: "ui-br-agency.title.textContents.text.label" }),
            cellRenderer: function (row) { return (React.createElement("span", { className: css.textOverflow }, row.text || "-")); },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.title.textContents.language.label",
            }),
            cellRenderer: function (row) { var _a; return ((_a = row.language) === null || _a === void 0 ? void 0 : _a.description) || "-"; },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.title.textContents.textAuthor.label",
            }),
            cellRenderer: function (row) { return row.textAuthor || "-"; },
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 }, contentFields.length > 0 ? (React.createElement(EntityRowList, { data: contentData, columns: columns, onEdit: function (row) {
                    return openEditor(getValues("textContents.".concat(row._index)), row._index);
                }, onDelete: function (row) { return removeContent(row._index); } })) : (React.createElement("div", { className: css.emptyState },
                React.createElement(FormattedMessage, { id: "ui-br-agency.title.textContents.empty" }))))),
        errorMessages.length > 0 && (React.createElement(Row, { "data-error-field": "textContents" },
            React.createElement(Col, { xs: 12 },
                React.createElement(MessageBanner, { type: "error", className: css.tableErrorBanner }, errorMessages.map(function (msg) { return (React.createElement("div", { key: msg }, msg)); }))))),
        React.createElement(FormSectionModal, { open: isOpen, isEditing: isEditing, draft: draft, onDraftChange: setDraft, onSave: saveItem, onClose: closeEditor, addLabelId: "ui-br-agency.title.textContents.form.add.title", editLabelId: "ui-br-agency.title.textContents.form.edit.title", size: "large", fields: [
                {
                    key: "type",
                    labelId: "ui-br-agency.title.content.type.label",
                    type: "onix",
                    required: true,
                    dataOptions: (_a = textContentTypeTable === null || textContentTypeTable === void 0 ? void 0 : textContentTypeTable.onixCodetableItems) !== null && _a !== void 0 ? _a : [],
                    loading: textContentTypeLoading,
                    codetableStatus: textContentTypeStatus,
                },
                {
                    key: "language",
                    labelId: "ui-br-agency.title.content.language.label",
                    type: "onix",
                    dataOptions: (_b = languageTable === null || languageTable === void 0 ? void 0 : languageTable.onixCodetableItems) !== null && _b !== void 0 ? _b : [],
                    loading: languageLoading,
                    codetableStatus: languageStatus,
                },
                {
                    key: "text",
                    labelId: "ui-br-agency.title.content.text.label",
                    type: "textarea",
                    required: true,
                    colSpan: 12,
                },
            ], validate: function (d) { var _a, _b; return !!((_a = d.type) === null || _a === void 0 ? void 0 : _a.value) && !!((_b = d.text) === null || _b === void 0 ? void 0 : _b.trim()); } }),
        React.createElement(Row, { className: css.actions },
            React.createElement(Col, { xs: 12 },
                React.createElement(Button, { buttonStyle: "primary", onClick: function () { return openEditor(); } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.title.form.add.content" }))))));
};
export default TitleTextContentsForm;
